module.exports = __webpack_public_path__ + "static/media/health.1884ba46.png";